import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import Layout from './components/layout/layout';
import NotFoundPage from './pages/NotFoundPage';
import SignUp from './pages/auth/sign-up';
import Login from './pages/auth/login';
import ForgotPassword from './pages/auth/forgot-password';
import { getAccounts } from './services/auth-service';
import { UserProvider } from './components/context/user-context';
import { AccountsContext, AccountsProvider } from './components/context/account-context';
import VerifyModal from './pages/home/verify-modal';
import CreateAccountModal from './pages/home/create-accounts';
import Home from './pages/home';
import Vehicles from './pages/vehicles';
import Incidents from './pages/incidents';
import Tires from './pages/tires';
import Meters from './pages/meters';
import Services from './pages/services';
import Vendors from './pages/vendors';
import Expenses from './pages/expenses';
import Users from './pages/users';
import { GlobalDataProvider } from './components/context/global-data-context';
import Jobs from './pages/jobs';
import JobView from './pages/jobs/views';
import ServiceReminders from './pages/reminders/service-reminders';
import RenewalReminders from './pages/reminders/renewal-reminders';
import Preferences from './pages/preferences';
import ReportsExpensesVehicle from './pages/reports/expenses/vehicles';
import ReportsExpensesVendor from './pages/reports/expenses/vendors';
import ReportsExpensesCategory from './pages/reports/expenses/category';
import Ads from './pages/ads';
import Notifications from './pages/notifications';
import Fuels from './pages/fuels';
import Clocks from './pages/clocks';
import VehicleViews from './pages/vehicles/view';
import RenewalViews from './pages/renewals/view';
import Renewals from './pages/renewals';
import MapPage from './pages/incidents/map';
// import TagManager from 'react-gtm-module';



const PrivateRoute = ({ children }) => {
  const { setAttributes } = useContext(AccountsContext);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [showCreateAccountModal, setShowCreateAccountModal] = useState(false);

  // useEffect(() => {
  //   const tagManagerArgs = {
  //     gtmId: 'GTM-5M4R782M',
  //   };
  //   TagManager.initialize(tagManagerArgs);
  // }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const token = localStorage.getItem('authToken');
    const account = localStorage.getItem('accountId');

    if (!token) {
      return;
    }

    // Check for OTP verification
    if (user && user.status !== 'active' && !isVerified) {
      setShowVerifyModal(true);
      return;
    } else {
      setShowVerifyModal(false);
    }

    // Check for  account
    if (!account) {
      // No  account in localStorage, fetch from API
      const fetchAccounts = async () => {
        try {
          const response = await getAccounts(token);
          if (response.success) {
            const accounts = response.data.data || [];
            if (accounts.length === 0) {
              setShowCreateAccountModal(true);
            } else {
              localStorage.setItem('accountId', JSON.stringify(accounts[0].accountId));
              localStorage.setItem('accountAttributes', JSON.stringify(accounts[0].attributes));
              setShowCreateAccountModal(false);
              setAttributes(accounts[0].attributes);
            }
          } else {
            setShowCreateAccountModal(true);
          }
        } catch (error) {
          console.error('Error fetching  accounts:', error);
          setShowCreateAccountModal(true);
        }
      };

      fetchAccounts();
    } else {
      setShowCreateAccountModal(false);
    }
  }, [isVerified]);

  const token = localStorage.getItem('authToken');
  if (!token) {
    return <Navigate to="/" />;
  }

  return (
    <div className="relative min-h-screen">
      <div
        className={`transition-all duration-300 ${showVerifyModal || showCreateAccountModal ? 'opacity-50 pointer-events-none' : 'opacity-100'
          }`}
      >
        {children}
      </div>
      {showVerifyModal && (
        <div className="fixed inset-0 z-50">
          <VerifyModal
            setShowModal={setShowVerifyModal}
            onSuccess={() => setIsVerified(true)}
          />
        </div>
      )}
      {showCreateAccountModal && (
        <div className="fixed inset-0 z-50">
          <CreateAccountModal
            setShowCreateModal={setShowCreateAccountModal}
            token={token}
            onSuccess={() => setShowCreateAccountModal(false)}
          />
        </div>
      )}
    </div>
  );
};

function App() {
  return (
    <GlobalDataProvider>
      <UserProvider>
        <AccountsProvider>
          <Router>
            <Routes>
              <Route
                element={
                  <PrivateRoute>
                    <Layout />
                  </PrivateRoute>
                }
              >
                <Route path="/dashboard" element={<Home />} />
                <Route path="/vehicles" element={<Vehicles />} />
                <Route path="/vehicles/:vehicleId" element={<VehicleViews />} />
                <Route path="/incidents" element={<Incidents />} />
                <Route path="/fuels" element={<Fuels />} />
                <Route path="/tires" element={<Tires />} />
                <Route path="/meters" element={<Meters />} />
                <Route path="/services" element={<Services />} />
                <Route path="/renewals" element={<Renewals />} />
                <Route path="/renewals/:renewalId" element={<RenewalViews />} />
                <Route path="/vendors" element={<Vendors />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route path="/settings/users" element={<Users />} />
                <Route path="/settings/preferences" element={<Preferences />} />
                <Route path="/fsm/jobs" element={<Jobs />} />
                <Route path="/fsm/jobs/:jobId" element={<JobView />} />
                <Route path="/fsm/clock" element={<Clocks />} />
                <Route path="/reminders/services" element={<ServiceReminders />} />
                <Route path="/reminders/renewals" element={<RenewalReminders />} />
                <Route path="/reports/expenses/vehicles" element={<ReportsExpensesVehicle />} />
                <Route path="/reports/expenses/vendors" element={<ReportsExpensesVendor />} />
                <Route path="/reports/expenses/categories" element={<ReportsExpensesCategory />} />
                <Route path="/settings/notifications" element={<Notifications />} />
                <Route path="/offers" element={<Ads />} />
              </Route>

              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/incidents/map" element={<MapPage />} />

              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Router>
        </AccountsProvider>
      </UserProvider>
    </GlobalDataProvider>
  );
}

export default App;